<template>
    <preloader v-if="loading" :display="loading" />
    <div v-else class="overview-v3">
        <div class="overview-v3__subscription-summary">
            <div class="overview-v3__subscription-summary__information">
                <div class="overview-v3__subscription-summary__information-plan">
                    <p>
                        <span class="typographies-paragraph-medium-black">
                            {{ $l10n.__('Nombre d’utilisateurs') }}
                        </span>
                        <span class="typographies-paragraph-medium-regular">
                            {{ staffsNumber }}
                        </span>
                    </p>
                    <p>
                        <span class="typographies-paragraph-medium-black">
                            {{ $l10n.__("Dates d'abonnement") }}
                        </span>
                        <span class="typographies-paragraph-medium-regular">
                            {{ subscriptionDataHumanized }}
                        </span>
                    </p>
                    <p>
                        <span class="typographies-paragraph-medium-black">
                            {{ $l10n.__("Type d'abonnement") }}
                        </span>
                        <span class="typographies-paragraph-medium-regular">
                            {{ subscriptionType }}
                        </span>
                    </p>
                </div>
                <CompassButton
                    :label="$t.__('common.actions.edit_subscription')"
                    @click="upsellCart"
                />
            </div>
            <div class="overview-v3__subscription-summary__manager">
                <h3 class="typographies-heading-h3">{{ $l10n.__('Gérer mon abonnement') }}</h3>

                <div
                    v-for="action in actions"
                    :key="action.section"
                    class="manage-chargebee-account__container-btn"
                >
                    <CompassPlainButton
                        :label="action.labelBtn"
                        @click="openCbPortalSection(action.section)"
                    />
                </div>
            </div>
        </div>
        <ChargebeeSubscriptionOverviewPluginsV3
            :subscriptionItems="subscriptionChargebee.subscription_items"
        />
        <QuotaSummary
            :isChargebeeProvider="true"
            :chargebeeThirdPartyPayerId="chargebeeThirdPartyPayerId"
            :licenseAssignement="licenseAssignement"
        />
    </div>
</template>
<script>
import { fetchSubscription } from 'api/chargebee/chargebeeService';
import QuotaSummary from 'vcomponents/sellsyaccountmanager/SubscriptionManager/quota/QuotaSummary.vue';
import ChargebeeSubscriptionOverviewPluginsV3 from 'vcomponents/sellsyaccountmanager/SubscriptionManager/chargebeeSubscriptionManagerV3/ChargebeeSubscriptionOverviewPluginsV3.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import Feature from 'Services/Feature';
import { goToUrl } from 'js/vue/helpers.js';
export default {
    components: {
        Preloader,
        QuotaSummary,
        ChargebeeSubscriptionOverviewPluginsV3,
    },
    props: {
        chargebeeThirdPartyPayerId: {
            type: String,
            required: false,
            default: '',
        },
        licenseAssignement: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            subscriptionChargebee: {},
            customerChargebee: {},
            staffsNumber: 0,
            subscription: {},
            loading: true,
            actions: [
                {
                    labelBtn: this.$l10n.__('Informations sur le compte'),
                    section: 'ACCOUNT_DETAILS',
                },
                {
                    labelBtn: this.$l10n.__('Adresse de facturation'),
                    section: 'ADDRESS',
                },
                {
                    labelBtn: this.$l10n.__('Méthodes de paiement'),
                    section: 'PAYMENT_SOURCES',
                },
                {
                    labelBtn: this.$l10n.__('Historique de facturation'),
                    section: 'BILLING_HISTORY',
                },
            ],
            subscriptionType: '',
        };
    },
    computed: {
        subscriptionDataHumanized() {
            const { billing_settings } = this.subscription;
            if (!billing_settings) {
                return '';
            }
            const { service_start_date, service_end_date } = billing_settings;

            const startTimestamp = new Date(service_start_date).getTime() / 1000;
            const endTimestamp = new Date(service_end_date).getTime() / 1000;

            const startDateFormatted =
                window.sellsyapp.config.globalProperties.$filters.dateFormatter(
                    startTimestamp,
                    'NORMAL_DATE',
                );
            const endDateFormatted =
                window.sellsyapp.config.globalProperties.$filters.dateFormatter(
                    endTimestamp,
                    'NORMAL_DATE',
                );

            return this.$l10n.__(`Du ${startDateFormatted} au ${endDateFormatted}`);
        },
    },
    async created() {
        try {
            const res = await fetchSubscription();
            this.subscriptionChargebee = res.data.subscription;
            this.customerChargebee = res.data.customer;
            this.staffsNumber = this.subscriptionChargebee?.subscription_items.reduce(
                (acc, item) => {
                    const quantity = item.item_price_id.includes('pack_crm') ? item.quantity : 0;
                    return acc + quantity;
                },
                0,
            );
            this.subscriptionType =
                this.subscriptionChargebee.billing_period_unit === 'year'
                    ? this.$l10n.__('Annuel')
                    : this.$l10n.__('Mensuel');
            const res2 = await ApiClient.get('/settings/subscription');
            this.subscription = res2.data;
        } catch (err) {
            this.$pushToast({
                text: this.$l10n.__(
                    'Une erreur est survenue lors de la récuperation des informations de votre abonnement, merci de contacter le support',
                ),
                type: 'error',
                icon: false,
            });
        } finally {
            this.loading = false;
        }
    },
    beforeUnmount() {
        window.ChargebeeGlobal.clearChargebeeScript();
    },
    methods: {
        async openCbPortalSection(section) {
            await window.ChargebeeGlobal.openCbPortalSection(section);
        },
        upsellCart() {
            if (Feature.isEnabled('chargebee-upsell-selfservice')) {
                goToUrl(
                    this.$router.resolve({
                        name: 'chargebee.upsell.cart',
                    }).href,
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.overview-v3 {
    &__subscription-summary {
        display: flex;
        gap: var(--spacing-3);

        &__information {
            align-items: flex-start;
            background: var(--colors-common-background-subtle);
            border-radius: 4px;
            display: flex;
            justify-content: space-between;
            padding: var(--spacing-4);
            width: 60%;

            &-plan {
                display: flex;
                flex-direction: column;
                gap: var(--spacing-2);

                p {
                    display: flex;
                    flex-direction: column;
                    margin: 0;
                }
            }
        }

        &__manager {
            border: 1px solid var(--colors-common-border-default);
            border-radius: 4px;
            flex-grow: 1;
            padding: var(--spacing-3);

            h3 {
                border-bottom: 1px solid var(--colors-common-border-lighter);
                margin: 0;
                padding-bottom: var(--spacing-1);
            }

            div {
                border-bottom: 1px solid var(--colors-common-border-lighter);
                padding: var(--spacing-1) 0;
            }
        }
    }
}

.manage-chargebee-account__container-btn {
    border-bottom: 1px solid var(--colors-common-border-lighter);
    padding: var(--spacing-1) 0;
}
</style>
